@if (initialized && dto) {
    @switch (uiMode) {
        @case ('side') {
            <campaign-type-config-object-component-side
                    [objectIdentifier]="objectIdentifier"
                    [dto]="dto"
                    [uiMode]="uiMode"
                    (onNavigationItems)="handleNavigationItems($event)"
                    (activeNavigationItemChange)="handleNavigationChange($event)"
            ></campaign-type-config-object-component-side>
        }
        @case ('mini-side') {
            <campaign-type-config-object-component-side
                    [objectIdentifier]="objectIdentifier"
                    [dto]="dto"
                    [uiMode]="uiMode"
                    (onNavigationItems)="handleNavigationItems($event)"
                    (activeNavigationItemChange)="handleNavigationChange($event)"
            ></campaign-type-config-object-component-side>
        }
        @default {
            <campaign-type-config-object-component-full
                    [objectIdentifier]="objectIdentifier"
                    [dto]="dto"
                    [uiMode]="uiMode"
                    (onNavigationItems)="handleNavigationItems($event)"
                    (activeNavigationItemChange)="handleNavigationChange($event)"
            ></campaign-type-config-object-component-full>
        }
    }
}
